import { render, staticRenderFns } from "./RootErrorDialog.vue?vue&type=template&id=6b7baab3"
import script from "./RootErrorDialog.vue?vue&type=script&lang=js"
export * from "./RootErrorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports